import { render, staticRenderFns } from "./CaseOverviewInsureds.vue?vue&type=template&id=0444265c"
import script from "./CaseOverviewInsureds.vue?vue&type=script&lang=js"
export * from "./CaseOverviewInsureds.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports